import { Button, Card, IconButton, TextField } from "@material-ui/core";
import Divider from "@material-ui/core/Divider";
import Paper from "@material-ui/core/Paper";
import Table from "@material-ui/core/Table";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import { Check, Close, SearchOutlined, Visibility } from "@material-ui/icons";
import {
  Dialog,
  DialogActions,
  DialogTitle,
  Pagination,
  Tooltip,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router";
import { startLoading, stopLoading } from "../../actions/loadingAction";
import {
  errorFetchApplicants,
  errorSnackbar,
  successSnackbar,
} from "../../actions/snackbarActions";
import { Endpoint, Status } from "../../apis/apiConstants";
import AjaxHelper from "../../apis/apiRequest";
import { APPROVAL } from "../../common/constants";
import MTextField from "../../components/MTextField";
import { isFieldEmpty } from "../../helpers/appFieldValidation";
import { getCopy } from "../../helpers/utils.helper";
import "./applicants.scss";
import NodataComponent from "../../components/NodataComponent";

export default function Applicants(props) {
  const [applicants, setApplicants] = useState([]);
  const [applicantPages, setApplicantPages] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [searchText, setSearchText] = useState("");
  const [selectedUser, setSelectedUser] = useState(null);
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));
  const [open, setOpen] = React.useState(false);
  const [rejectionOpen, setRejectionOpen] = React.useState(false);
  const navigate = useNavigate();

  const dispatch = useDispatch();

  React.useEffect(() => {
    getApplicantCount("");
    getAllApplicants(1, "");
  }, []);

  const getAllApplicants = (page, search) => {
    dispatch(startLoading);
    AjaxHelper.getApi(navigate, Endpoint.GET_APPLICANTS, {}, { page, search })
      .then((response) => {
        dispatch(stopLoading);
        if (response.data.status === Status.API_SUCCESS) {
          setApplicants(response.data.data);
          setSelectedUser(response.data.data[0]);
        } else if (response.data.status === Status.API_NO_CONTENT) {
          setApplicants([]);
          dispatch(errorSnackbar(response.data.message));
        } else {
          dispatch(errorSnackbar(response.data.message));
        }
      })
      .catch((error) => {
        dispatch(errorFetchApplicants);
      });
  };

  const getApplicantCount = (search) => {
    AjaxHelper.getApi(navigate, Endpoint.GET_APPLICANTS_PAGES, {}, { search })
      .then((response) => {
        if (response.data.status === Status.API_SUCCESS) {
          setApplicantPages(response.data.data.pages);
        }
      })
      .catch((error) => {
        dispatch(errorSnackbar("Error in fetching member pages."));
      });
  };

  const setUserApproval = (applicant, approval) => {
    if (approval === APPROVAL.REJECT && isFieldEmpty(applicant.reason)) {
      dispatch(
        errorSnackbar("Please enter a reason for rejecting the application")
      );
      return;
    }
    setRejectionOpen(false);
    dispatch(startLoading);
    AjaxHelper.postApi(navigate, Endpoint.UPDATE_USER_APPROVAL, {
      userCode: applicant.userCode,
      jamatCode: applicant.jamatCode,
      reason: applicant.reason,
      email: applicant.email,
      approval,
    })
      .then((response) => {
        dispatch(stopLoading);
        if (response.data.status === Status.API_SUCCESS) {
          dispatch(
            successSnackbar(
              `${applicant.firstName}'s approval set to ${approval}`
            )
          );
          getApplicantsData();
        }
      })
      .catch((error) => {
        dispatch(stopLoading);
        dispatch(errorSnackbar("Error in fetching member pages."));
      });
  };

  const onPageChange = (page) => {
    setCurrentPage(page);
    getAllApplicants(page);
  };

  const getApplicantsData = () => {
    getAllApplicants(searchText.length > 0 ? 1 : currentPage, searchText);
    getApplicantCount(searchText);
  };

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleRejectionClose = () => {
    setRejectionOpen(false);
  };

  const handleRejectionOpen = () => {
    setRejectionOpen(true);
  };

  const getUserFields = () => {
    if (selectedUser) {
      return (
        <div className={"d-flex flex-column gap-3 p-3"}>
          <div className={"d-flex flex-row gap-1"}>
            <div className={"col-md-6 col-sm-12"}>
              <div className={"font-bold font-14"}>Father's name</div>
              <div>{selectedUser.fathersName}</div>
            </div>
            <div className={"col-md-6 col-sm-12"}>
              <div className={"font-bold font-14"}>Mother's name</div>
              <div>{selectedUser.mothersName}</div>
            </div>
          </div>

          <div className={"d-flex flex-row gap-1"}>
            <div className={"col-md-6 col-sm-12"}>
              <div className={"font-bold font-14"}>Marital status</div>
              <div>{selectedUser.maritalStatus}</div>
            </div>
            <div className={"col-md-6 col-sm-12"}>
              <div className={"font-bold font-14"}>Date of birth</div>
              <div>{selectedUser.dateOfBirth}</div>
            </div>
          </div>

          <div className={"d-flex flex-row gap-1"}>
            <div className={"col-md-6 col-sm-12"}>
              <div className={"font-bold font-14"}>Spouse</div>
              <div>{selectedUser.spouseName}</div>
            </div>
            <div className={"col-md-6 col-sm-12"}>
              <div className={"font-bold font-14"}>Gender</div>
              <div>{selectedUser.gender}</div>
            </div>
          </div>

          <div className={"d-flex flex-row gap-1"}>
            <div className={"col-md-6 col-sm-12"}>
              <div className={"font-bold font-14"}>Mobile</div>
              <div>
                {"+" +
                  selectedUser.countryCallingCode +
                  "-" +
                  selectedUser.mobile}
              </div>
            </div>
            <div className={"col-md-6 col-sm-12"}>
              <div className={"font-bold font-14"}>Email</div>
              <div>{selectedUser.email}</div>
            </div>
          </div>

          <div className={"d-flex flex-row gap-1"}>
            <div className={"col-md-6 col-sm-12"}>
              <div className={"font-bold font-14"}>Qualification</div>
              {selectedUser.qualification.map((qualification, index) => (
                <div>{index + 1 + ") " + qualification}</div>
              ))}
            </div>
            <div className={"col-md-6 col-sm-12"}>
              <div className={"font-bold font-14"}>Profession</div>
              {selectedUser.profession.map((profession, index) => (
                <div>{index + 1 + ") " + profession}</div>
              ))}
            </div>
          </div>

          <div className={"d-flex flex-row gap-1"}>
            <div className={"col-md-6 col-sm-12"}>
              <div className={"font-bold font-14"}>Blood group</div>
              <div>{selectedUser.bloodGroup}</div>
            </div>
          </div>

          <div className={"d-flex flex-row gap-1"}>
            <div className={"col-md-12 col-sm-12"}>
              <div className={"font-bold font-14"}>Address</div>
              {selectedUser.address[0].landmark ? (
                <div>
                  {selectedUser.address[0].society +
                    ", " +
                    selectedUser.address[0].street +
                    ", " +
                    selectedUser.address[0].landmark +
                    ", " +
                    selectedUser.city +
                    ", " +
                    selectedUser.state +
                    ", " +
                    selectedUser.country +
                    ", PIN:" +
                    selectedUser.zip}
                </div>
              ) : (
                <div>
                  {selectedUser.address[0].society +
                    ", " +
                    selectedUser.address[0].street +
                    ", " +
                    selectedUser.city +
                    ", " +
                    selectedUser.state +
                    ", " +
                    selectedUser.country +
                    " PIN:" +
                    selectedUser.zip}
                </div>
              )}
            </div>
          </div>
        </div>
      );
    } else {
      return null;
    }
  };

  const getApplicantsView = () => {
    return applicants.map((applicant) => (
      <TableRow>
        <TableCell>{applicant.userCode}</TableCell>
        <TableCell>
          {applicant.title +
            " " +
            applicant.firstName +
            " " +
            applicant.lastName}
        </TableCell>
        <TableCell>{applicant.email}</TableCell>
        <TableCell>{applicant.jamatName}</TableCell>
        <TableCell>
          {applicant.city + "," + applicant.state + "," + applicant.country}
        </TableCell>
        <TableCell align="center">
          <Tooltip title={"View"}>
            <IconButton
              onClick={() => {
                setSelectedUser(applicant);
                handleClickOpen();
              }}
            >
              <Visibility color={"primary"} />
            </IconButton>
          </Tooltip>
          <Tooltip title={"Approve"} className={"approve-icon"}>
            <IconButton
              onClick={() => {
                setUserApproval(applicant, APPROVAL.ACCEPT);
              }}
            >
              <Check />
            </IconButton>
          </Tooltip>
          <Tooltip title={"Reject"} className={"reject-icon"}>
            <IconButton
              onClick={() => {
                setSelectedUser(applicant);
                handleRejectionOpen();
              }}
            >
              <Close />
            </IconButton>
          </Tooltip>
        </TableCell>
      </TableRow>
    ));
  };
  return (
    <div className={"applicants-component d-flex flex-column p-md-3"}>
      <div className="mb-3 col-md-3 col-sm-12">
        <TextField
          fullWidth
          placeholder="Search"
          value={searchText}
          onChange={(event) => {
            setSearchText(event.target.value);
          }}
          InputProps={{
            endAdornment: (
              <IconButton onClick={() => getApplicantsData()}>
                <SearchOutlined />
              </IconButton>
            ),
          }}
        />
      </div>
      <Card className="innerCard mt-3 " variant="outlined">
        <TableContainer component={Paper}>
          <Table aria-label="simple table">
            <TableHead>
              <TableRow className={"background-color-head"}>
                <TableCell>
                  <span className={"font-bold font-18"}>Memon ID</span>
                </TableCell>
                <TableCell>
                  <span className={"font-bold font-18"}>Name</span>
                </TableCell>
                <TableCell>
                  <span className={"font-bold font-18"}>Email</span>
                </TableCell>
                <TableCell>
                  <span className={"font-bold font-18"}>Jamaat</span>
                </TableCell>
                <TableCell>
                  <span className={"font-bold font-18"}>Address</span>
                </TableCell>
                <TableCell align="center">
                  <span className={"font-bold font-18"}>Action</span>
                </TableCell>
              </TableRow>
            </TableHead>
            {getApplicantsView()}
          </Table>
        </TableContainer>
        {applicants.length > 0 ? null : <NodataComponent />}
        {applicantPages > 0 ? (
          <Pagination
            className={"mpagination"}
            count={applicantPages}
            value={currentPage}
            variant="outlined"
            shape="rounded"
            onChange={(event, page) => onPageChange(page)}
          />
        ) : null}
      </Card>
      <Dialog fullScreen={fullScreen} open={open} onClose={handleClose}>
        <DialogTitle className={"background-color-head"}>
          <span className={"font-bold font-18"}>
            {selectedUser
              ? selectedUser.title +
                " " +
                selectedUser.firstName +
                " " +
                selectedUser.lastName +
                " (" +
                selectedUser.userCode +
                ")"
              : ""}
          </span>
        </DialogTitle>
        <Divider />

        <div className={"user-form"}>
          {selectedUser ? getUserFields() : null}
        </div>
        <DialogActions>
          <Button onClick={handleClose}>Ok</Button>
        </DialogActions>
      </Dialog>

      <Dialog
        fullScreen={fullScreen}
        open={rejectionOpen}
        onClose={handleRejectionClose}
      >
        <DialogTitle className={"background-color-head"}>
          <span className={"font-bold font-18"}>
            Please state the reason for the rejection of this application.
          </span>
        </DialogTitle>
        <Divider />

        <div className={"rejection-form"}>
          {selectedUser ? (
            <MTextField
              id={"reason"}
              name={"reason"}
              className="col-12"
              required={true}
              label={`Reason`}
              value={selectedUser["reason"]}
              onChange={(event) => {
                const updatedUser = getCopy(selectedUser);
                updatedUser[event.target.name] = event.target.value;
                setSelectedUser(updatedUser);
              }}
              disabled={false}
              error={false}
              placeholder={"Enter a reason."}
            />
          ) : null}
        </div>
        <DialogActions>
          <Button onClick={handleRejectionClose}>Cancel</Button>
          <Button
            onClick={() => setUserApproval(selectedUser, APPROVAL.REJECT)}
          >
            Ok
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
